import { ITypedReduxAction } from 'shared/types/redux';

export enum ENewbuildingHousesActionTypes {
  META_REFRESH_COMPLETE = 'filters/layoutMeta/META_REFRESH_COMPLETE',
}

export interface ILayoutMetaRefreshCompletePayload {
  layoutsCountMeta: number;
}

export type ILayoutMetaRefreshCompleteAction = ITypedReduxAction<
  ENewbuildingHousesActionTypes.META_REFRESH_COMPLETE,
  ILayoutMetaRefreshCompletePayload
>;
